const menuSlider = document.querySelectorAll('[data-slider="menu-slider"]');

const menuSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    1024: {
      freeMode: false,
      slidesPerGroup: 2,
    },
  },
};

const markLastVisibleSlides = () => {
  menuSlider.forEach((slider) => {
    const slides = slider.querySelectorAll('.swiper-slide-visible');
    const slidesArray = [...slides];

    slider
      .querySelectorAll('.swiper-slide.is-last-visible, .swiper-slide.is-last-middle')
      .forEach((el) => el.classList.remove('is-last-visible', 'is-last-middle'));

    // ---- ADD LAST 3 ----
    const last3 = slidesArray.slice(-3);
    last3.forEach((slide) => slide.classList.add('is-last-visible'));

    // ---- ADD MIDDLE 2
    const before3 = slidesArray.slice(-5, -3);
    before3.forEach((slide) => slide.classList.add('is-last-middle'));
  });
};

const initMenuSlider = () => {
  menuSlider.forEach((el) => {
    const menuSliderParent = el.closest('.menu-slider');
    const arrowRight = menuSliderParent.querySelector('.arrow-right');
    const arrowLeft = menuSliderParent.querySelector('.arrow-left');
    const scrollbar = menuSliderParent.querySelector('.swiper-scrollbar');

    menuSliderOptions.navigation.nextEl = arrowRight;
    menuSliderOptions.navigation.prevEl = arrowLeft;
    menuSliderOptions.scrollbar.el = scrollbar;
    const menuSliderInit = new Swiper(el, menuSliderOptions);

    menuSliderInit.on('slideChange transitionEnd resize', markLastVisibleSlides);

    const allSlides = menuSliderParent.querySelectorAll('.swiper-slide');
    let openTimer;
    let closeTimer;

    const toggleMenuCard = () => {
      const openItem = menuSliderParent.querySelector('.swiper-slide.is-open');
      if (openItem) {
        openItem.classList.remove('is-open');
      }
    };

    const handleMouseEnter = (slide) => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => {
        toggleMenuCard();
        slide.classList.add('is-open');
      }, 200);
    };

    const handleMouseLeave = (slide) => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        slide.classList.remove('is-open');
      }, 200);
    };

    allSlides.forEach((slide) => {
      const menuDropdown = slide.querySelector('.menu-slider__dropdown');
      if (!menuDropdown) return;

      slide.addEventListener('mouseenter', (e) => {
        handleMouseEnter(e.currentTarget);
      });

      slide.addEventListener('mouseleave', (e) => {
        handleMouseLeave(e.currentTarget);
      });
    });

    menuSliderParent.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      toggleMenuCard();
    });
  });
};

initMenuSlider();

// run on load
markLastVisibleSlides();

setupResponsiveSliders({
  sliderElements: menuSlider,
  breakpoint: 767,
  initSlider: initMenuSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
